import { type ValidateDocumentAdapter } from '../../validation/protocols/validate-document-adapter'
import { validateCNPJ, validateCPF } from 'validations-br'

export class DocumentValidatorAdapter implements ValidateDocumentAdapter {
  validate (value: string): boolean {
    const isCPF = validateCPF(value)
    if (isCPF) return true
    return validateCNPJ(value)
  }
}
